export default {
    data() {
        return {
            pt: {
                listen: 'Escute nas Plataformas',
                share: 'Compartilhar',
                access: 'Acessar',
                copy: 'Copiar'
            },
            en: {
                listen: 'Listen on platforms',
                share: 'Share',
                access: 'Access',
                copy: 'Copy'
            },
            it: {
                listen: 'Ascolta sulle Piattaforme',
                share: 'Condividi',
                access: 'Accedi',
                copy: 'Copia'
            }
        }
    }
}
